import { configure } from "@culturehq/client";

switch (process.env.NODE_ENV) { // eslint-disable-line default-case
  case "development":
    configure({
      apiHost: "http://localhost:3000",
      awsAccessKeyId: "access-key-id",
      signerURL: "http://localhost:3001",
      uploadBucket: "http://localhost:3001"
    });

    break;
  case "test":
    configure({
      apiHost: "https://api-staging.culturehq.com",
      awsAccessKeyId: "AKIA2OD42LXEEQNIKOWR",
      signerURL: "https://0f8wfhpcb9.execute-api.us-west-2.amazonaws.com/production/signature",
      uploadBucket: "https://culturehq-direct-uploads-staging.s3-us-west-2.amazonaws.com"
    });

    break;
  case "production":
    if (window.location.host.split(".")[1] === "localhost:4000") {
      // TODO: awsAccessKeyId, signerURL
      configure({
        apiHost: "https://api-staging.culturehq.com",
        awsAccessKeyId: "AKIA2OD42LXEEQNIKOWR",
        signerURL: "https://0f8wfhpcb9.execute-api.us-west-2.amazonaws.com/production/signature",
        uploadBucket: "https://culturehq-direct-uploads-staging.s3-us-west-2.amazonaws.com"
      });
    }

    // skipPreflightChecks();
    if (window.location.host.split(".")[0].includes("-staging")) {
      // TODO: awsAccessKeyId, signerURL
      configure({
        apiHost: "https://api-staging.culturehq.com",
        awsAccessKeyId: "AKIA2OD42LXEEQNIKOWR",
        signerURL: "https://0f8wfhpcb9.execute-api.us-west-2.amazonaws.com/production/signature",
        uploadBucket: "https://culturehq-direct-uploads-staging.s3-us-west-2.amazonaws.com"
      });
    }

    if (window.location.host.split(".")[0] === "eu-platform") {
      configure({
        apiHost: "https://uk-api.culturehq.com",
        awsAccessKeyId: "AKIAIPWT257FWZ5I4ZGQ",
        signerURL: "https://qyo2hippvb.execute-api.eu-west-1.amazonaws.com/production/signature",
        uploadBucket: "https://culturehq-direct-uploads-ireland.s3-eu-west-1.amazonaws.com"
      });
    }

    // this is for cypress, when creating a production build to run from the localhost
    // as production env
    if (window.location.host.split(".")[0] === "localhost:4000") {
      configure({
        apiHost: "https://api-staging.culturehq.com",
        awsAccessKeyId: "AKIA2OD42LXEEQNIKOWR",
        signerURL: "https://0f8wfhpcb9.execute-api.us-west-2.amazonaws.com/production/signature",
        uploadBucket: "https://culturehq-direct-uploads-staging.s3-us-west-2.amazonaws.com"
      });
    }
    break;
}
